"use strict";
// Copyright (C) 2017-2024 Smart code 203358507
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var useBinaryState_1 = __importDefault(require("stremio/common/useBinaryState"));
var useOutsideClick_1 = __importDefault(require("stremio/common/useOutsideClick"));
var Popup_1 = __importDefault(require("stremio/components/Popup"));
var Dropdown_1 = __importDefault(require("./Dropdown"));
var Label_1 = __importDefault(require("./Label"));
var MultiselectMenu_less_1 = __importDefault(require("./MultiselectMenu.less"));
var MultiselectMenu = function (_a) {
    var _b;
    var className = _a.className, title = _a.title, icon = _a.icon, options = _a.options, value = _a.value, disabled = _a.disabled, _c = _a.portal, portal = _c === void 0 ? false : _c, onSelect = _a.onSelect;
    var _d = (0, useBinaryState_1.default)(false), menuOpen = _d[0], closeMenu = _d[2], toggleMenu = _d[3];
    var _e = react_1.default.useState(false), autoFocus = _e[0], setAutoFocus = _e[1];
    var multiselectMenuRef = (0, useOutsideClick_1.default)(closeMenu);
    var _f = react_1.default.useState(0), level = _f[0], setLevel = _f[1];
    var selectedOption = options.find(function (opt) { return opt.value === value; });
    var labelText = typeof title === 'function' ? title() : title !== null && title !== void 0 ? title : selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label;
    var onOptionSelect = react_1.default.useCallback(function (selectedValue) {
        if (level) {
            setLevel(level + 1);
        }
        else {
            onSelect(selectedValue);
        }
        closeMenu();
    }, [level, onSelect, closeMenu]);
    var onLabelClick = react_1.default.useCallback(function (event) {
        setAutoFocus(event.detail === 0);
        toggleMenu();
    }, [toggleMenu]);
    var containerClassName = (0, classnames_1.default)(MultiselectMenu_less_1.default['multiselect-menu'], (_b = {}, _b[MultiselectMenu_less_1.default['active']] = menuOpen, _b), className);
    var renderLabel = react_1.default.useCallback(function (_a) {
        var ref = _a.ref, popupClassName = _a.className;
        return (react_1.default.createElement("div", { ref: ref, className: (0, classnames_1.default)(containerClassName, popupClassName) },
            react_1.default.createElement(Label_1.default, { text: labelText, icon: icon, disabled: disabled, open: menuOpen, onClick: onLabelClick })));
    }, [containerClassName, labelText, icon, disabled, menuOpen, onLabelClick]);
    var renderMenu = react_1.default.useCallback(function () { return menuOpen ? (react_1.default.createElement(Dropdown_1.default, { level: level, setLevel: setLevel, options: options, onSelect: onOptionSelect, menuOpen: menuOpen, value: value })) : null; }, [menuOpen, level, options, onOptionSelect, value]);
    return portal ? (react_1.default.createElement(Popup_1.default, { open: menuOpen, portal: true, autoFocus: autoFocus, menuClassName: MultiselectMenu_less_1.default['menu-popup'], onCloseRequest: closeMenu, renderLabel: renderLabel, renderMenu: renderMenu })) : (react_1.default.createElement("div", { className: containerClassName, ref: multiselectMenuRef },
        react_1.default.createElement(Label_1.default, { text: labelText, icon: icon, disabled: disabled, open: menuOpen, onClick: onLabelClick }),
        renderMenu()));
};
exports.default = MultiselectMenu;
